import { getToken, returnError } from './helperFunc';
import {
    getOutletAdditionalInfoAction,
    addOutletAdditionalInfoAction,
    updateOutletAdditionalInfoAction,
} from './requestEndpoints';

import { LOGOUT_SUCCESS } from './userReducer';

const SET_LOADING_ADDITIONAL_INFO = 'SET_LOADING_ADDITIONAL_INFO';
const CLEAR_ERROR_ADDITIONAL_INFO = 'CLEAR_ERROR_ADDITIONAL_INFO';

const GET_ADDITIONAL_INFO_SUCCESS = 'GET_ADDITIONAL_INFO_SUCCESS';
const GET_ADDITIONAL_INFO_FAIL = 'GET_ADDITIONAL_INFO_FAIL';

const ADD_ADDITIONAL_INFO_SUCCESS = 'ADD_ADDITIONAL_INFO_SUCCESS';
const ADD_ADDITIONAL_INFO_FAIL = 'ADD_ADDITIONAL_INFO_FAIL';

const UPDATE_ADDITIONAL_INFO_SUCCESS = 'UPDATE_ADDITIONAL_INFO_SUCCESS';
const UPDATE_ADDITIONAL_INFO_FAIL = 'UPDATE_ADDITIONAL_INFO_FAIL';

export const getOutletAdditionalInfo = (outletId) => async (dispatch, getState) => {
    try {
        dispatch({ type: CLEAR_ERROR_ADDITIONAL_INFO });
        dispatch({ type: SET_LOADING_ADDITIONAL_INFO });

        const { user } = getState();
        const token = getToken(user);

        const { data } = await getOutletAdditionalInfoAction(outletId, token);

        dispatch({ type: GET_ADDITIONAL_INFO_SUCCESS, payload: data });
    } catch (error) {
        dispatch({
            type: GET_ADDITIONAL_INFO_FAIL,
            payload: returnError(error),
        });
    }
};

export const addOutletAdditionalInfo = (formData) => async (dispatch, getState) => {
    try {
        dispatch({ type: CLEAR_ERROR_ADDITIONAL_INFO });
        dispatch({ type: SET_LOADING_ADDITIONAL_INFO });

        const { user } = getState();
        const token = getToken(user);

        const { data } = await addOutletAdditionalInfoAction(formData, token);

        dispatch({ type: ADD_ADDITIONAL_INFO_SUCCESS, payload: data });
        return data;
    } catch (error) {
        dispatch({ type: ADD_ADDITIONAL_INFO_FAIL, payload: returnError(error) });
        throw error;
    }
};

export const updateOutletAdditionalInfo = (formData) => async (dispatch, getState) => {
    try {
        dispatch({ type: CLEAR_ERROR_ADDITIONAL_INFO });
        dispatch({ type: SET_LOADING_ADDITIONAL_INFO });

        const { user } = getState();
        const token = getToken(user);

        const { data } = await updateOutletAdditionalInfoAction(formData, token);

        dispatch({ type: UPDATE_ADDITIONAL_INFO_SUCCESS, payload: data });
        return data;
    } catch (error) {
        dispatch({
            type: UPDATE_ADDITIONAL_INFO_FAIL,
            payload: returnError(error),
        });
        throw error;
    }
};

const initialState = {
    additionalInfo: null,
    loading: false,
    error: null,
};

const outletAdditionalInfoReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_LOADING_ADDITIONAL_INFO:
            return {
                ...state,
                loading: true,
            };

        case CLEAR_ERROR_ADDITIONAL_INFO:
            return {
                ...state,
                error: null,
            };

        case GET_ADDITIONAL_INFO_SUCCESS:
            return {
                ...state,
                additionalInfo: action.payload.data !== undefined ? action.payload.data : action.payload,
                loading: false,
                error: null,
            };

        case GET_ADDITIONAL_INFO_FAIL:
            return {
                ...state,
                error: action.payload,
                loading: false,
            };

        case ADD_ADDITIONAL_INFO_SUCCESS:
            return {
                ...state,
                additionalInfo: action.payload.data || action.payload,
                loading: false,
                error: null,
            };

        case ADD_ADDITIONAL_INFO_FAIL:
            return {
                ...state,
                error: action.payload,
                loading: false,
            };

        case UPDATE_ADDITIONAL_INFO_SUCCESS:
            return {
                ...state,
                additionalInfo: action.payload.data || action.payload,
                loading: false,
                error: null,
            };

        case UPDATE_ADDITIONAL_INFO_FAIL:
            return {
                ...state,
                error: action.payload,
                loading: false,
            };

        case LOGOUT_SUCCESS:
            return initialState;

        default:
            return state;
    }
};

export default outletAdditionalInfoReducer;